
export default {
  // Home page
  "airport_rankings": "Classement des aéroports",
  "recent_reviews": "Avis récents",
  "loading_reviews": "Chargement des avis...",
  "no_reviews": "Pas encore d'avis.",
  "share_experience": "Partagez votre expérience",
  "help_photographers": "Aidez d'autres photographes argentiques en partageant vos expériences dans les aéroports",
  "add_review": "Ajouter un avis",
  "loading_leaderboard": "Chargement du classement...",
  "no_reviews_yet": "Pas encore d'avis",
  "be_first": "Soyez le premier à évaluer un aéroport !",
  "best_airports": "Meilleurs aéroports",
  "worst_airports": "Pires aéroports",
  "success_rate": "Taux de réussite",
  "airport_name": "Nom de l'aéroport",
  "airport_location": "Emplacement",
  "score": "Score",
  "total_reviews": "Avis",
  "bottom_10_airports": "Les 10 pires aéroports selon les photographes argentiques",
  "top_10_airports": "Les 10 meilleurs aéroports selon les photographes argentiques",
  // Review tabs
  "all_reviews": "Tous les Avis",
  "verified_reviews": "Avis Vérifiés",
  "no_verified_reviews": "Pas encore d'avis vérifiés.",
  "creative_reviews": "Avis des Créatifs",
  "traveler_reviews": "Avis des Voyageurs",
  "no_creative_reviews": "Pas encore d'avis de créatifs vérifiés.",
  "no_traveler_reviews": "Pas encore d'avis de voyageurs vérifiés."
};
